export function InitialProfilePicture({
  name,
  size,
}: {
  name: string;
  size?: number;
}) {
  return (
    <div
      style={{
        width: size || "44px",
        height: size || "44px",
        borderRadius: "8px",
        backgroundColor: "#ccc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: "bold",
      }}
    >
      {name.charAt(0).toUpperCase()}
    </div>
  );
}
